import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import "./index.scss";
import {
  stepperVariantsMobile,
  stepVariants
} from "../../assets/framer/styles";

import step1SelectedIcon from "../../assets/icons/step1-selected.svg";
import step2Icon from "../../assets/icons/step2.svg";
import step2SelectedIcon from "../../assets/icons/step2-selected.svg";
import step3Icon from "../../assets/icons/step3.svg";
import step3SelectedIcon from "../../assets/icons/step3-selected.svg";
import step4Icon from "../../assets/icons/step4.svg";
import step4SelectedIcon from "../../assets/icons/step4-selected.svg";
import step5Icon from "../../assets/icons/step5.svg";
import successIcon from "../../assets/icons/success.svg";

// 1) Import i18n
import { useTranslation } from "react-i18next";

const steps = [
  {
    icon: null,
    selectedIcon: step1SelectedIcon
  },
  {
    icon: step2Icon,
    selectedIcon: step2SelectedIcon
  },
  {
    icon: step3Icon,
    selectedIcon: step3SelectedIcon
  },
  {
    icon: step4Icon,
    selectedIcon: step4SelectedIcon
  },
  {
    icon: step5Icon,
    selectedIcon: null
  }
];

const CustomStepperMobile = () => {
  const { t } = useTranslation(); // 2) Destructure t from react-i18next

  const [searchParams, setSearchParams] = useSearchParams();
  const stage = parseInt(searchParams.get("stage") || "1", 10);

  useEffect(() => {
    const rightSection = document.querySelector(".right-section");
    if (rightSection) {
      rightSection.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [stage]);

  const handleStepClick = (stepNumber) => {
    if (stage >= stepNumber) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("stage", stepNumber);
      setSearchParams(newParams);
    }
  };

  return (
    <motion.div
      className="custom-stepper-mobile"
      variants={stepperVariantsMobile}
      initial="normal"
      animate="normal"
      whileHover="hover"
    >
      <div className="step-icons-container">
        <div className="stepper-line" />
        {steps.map((step, index) => {
          const stepIndex = index + 1;
          const isActive = stage === stepIndex;
          const isSuccess = stage > stepIndex;

          return (
            <motion.div
              key={index}
              className={`step-icon-wrapper ${
                isActive ? "active" : isSuccess ? "success" : "inactive"
              }`}
              onClick={() => handleStepClick(stepIndex)}
              variants={stepVariants}
            >
              <div className="step-icon">
                <img
                  src={
                    // If final step is active => success icon
                    stage === steps.length && isActive
                      ? successIcon
                      : isActive
                      ? step.selectedIcon
                      : isSuccess
                      ? successIcon
                      : step.icon
                  }
                  // 3) Localize alt text: "STEP X"
                  alt={`${t("stepperStep")} ${stepIndex}`}
                />
              </div>
            </motion.div>
          );
        })}
      </div>

      <motion.div className="step-content" variants={stepVariants}>
        {/* 4) Use t("stepperStep") for "STEP" or "ÉTAPE" */}
        <p className="step-number">
          {t("stepperStep")} {stage}
        </p>
      </motion.div>
    </motion.div>
  );
};

export default CustomStepperMobile;
